import { QuoteSeverity, QuoteStatus } from '../types/quote';

enum QuotationStatusNumber {
    PENDING = 1,
    AWAITING_APPROVAL = 2,
    ACCEPTED = 3,
    REJECTED = 4,
    CANCELLED = 5,
    COMPLETED = 6,
    EXPIRED = 7,
    REACTIVATION_REQUEST_EXTERNAL = 8,
    REACTIVATION_REQUEST_INTERNAL = 9,
    READY_TO_SEND = 10
}

class QuoteMapper {
    /**
     * Returns a formatted string representation of the provided quote severity.
     *
     * @param {QuoteSeverity} quoteSeverity - The quote severity to format.
     * @returns {string|null} The formatted string corresponding to the quote severity,
     * or `null` if the reason is not recognized.
     */
    static getQuoteSeverity(quoteSeverity: string | null) {
        switch (quoteSeverity) {
            case QuoteSeverity.DisconnectedOrSafetyIssue:
                return 'Disconnected/Safety Issue';
            case QuoteSeverity.NonCompliantOrFaulty:
                return 'Non-Compliant/Faulty';
            case QuoteSeverity.Recommended:
                return 'Recommended';
            case QuoteSeverity.Urgent:
                return 'Urgent';
            case null:
                return 'Unknown severity';
            default:
                return quoteSeverity;
        }
    }

    static getQuoteStatusFromId(quotationStatusId: string | number | null) {
        let id = quotationStatusId;
        if (typeof quotationStatusId === 'string') {
            id = Number(quotationStatusId);
        }
        switch (id) {
            case QuotationStatusNumber.PENDING:
                return QuoteStatus.Pending;
            case QuotationStatusNumber.AWAITING_APPROVAL:
                return QuoteStatus.AwaitingApproval;
            case QuotationStatusNumber.ACCEPTED:
                return QuoteStatus.Accepted;
            case QuotationStatusNumber.REJECTED:
                return QuoteStatus.Rejected;
            case QuotationStatusNumber.CANCELLED:
                return QuoteStatus.Cancelled;
            case QuotationStatusNumber.COMPLETED:
                return QuoteStatus.Completed;
            case QuotationStatusNumber.EXPIRED:
                return QuoteStatus.Expired;
            case QuotationStatusNumber.REACTIVATION_REQUEST_EXTERNAL:
                return QuoteStatus.ReactivationRequestExternal;
            case QuotationStatusNumber.REACTIVATION_REQUEST_INTERNAL:
                return QuoteStatus.ReactivationRequestInternal;
            case QuotationStatusNumber.READY_TO_SEND:
                return QuoteStatus.ReadyToSend;
            default:
                throw new Error('Quotation status ID is required');
        }
    }
}

export { QuoteMapper };
